import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import { Typography, Card, Statistic, Spin, Button, Row, Col, Flex, Steps } from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import DetailForm from "./components/currentForms/DetailForm";
import TermsForm from "./components/currentForms/TermsForm";
import ChargesForm from "./components/currentForms/ChargesForm";
import Preview from "./components/currentForms/Preview";
import { useForm } from "antd/lib/form/Form";
import "./components/steps.css";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const EditCurrentAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = useForm();
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [current, setCurrent] = useState(0);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [customerParam, setCustomerParam] = useState({});

  // CHARGES FORM REQURED VARIABLES
  const [chargeTableCount, setChargeTableCount] = useState(0);
  const [chargeTableSource, setChargeTableSource] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [productData, setProductData] = useState([]);
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});
  const [interestCompoundingPeriodTypeOptions, setInterestCompoundingPeriodTypeOptions] = useState(
    []
  );
  const [interestPostingPeriodTypeOptions, setInterestPostingPeriodTypeOptions] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] = useState([]);
  const [interestCalculationDaysInYearTypeOptions, setInterestCalculationDaysInYearTypeOptions] =
    useState([]);
  const [lockinPeriodFrequencyTypeOptions, setLockinPeriodFrequencyTypeOptions] = useState([]);
  const [charges, setCharges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargesValue, setChargesValue] = useState(null);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    details: null,
    terms: null,
    charges: null,
  });

  useEffect(() => {
    getCustomerList();
  }, []);

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      console.log(customerDetail);
      return;
    }
    const filterBySearch = customerDetail.find(
      (item) => item?.accountNo === searchKey || item?.mobileNo === searchKey
    );
    console.log(filterBySearch);
    setCustomerParam(filterBySearch);
  }

  const onSearch = () => {
    if (customerParam && Object.keys(customerParam).length > 0) {
      getProductTemplate(customerParam);
    }
  };

  const onChangeProduct = (productParam) => {
    getCustomerProductTemplate(customerParam, productParam);
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const onFinishDetailsForm = (values) => {
    values.submittedOnDate = values.submittedOnDate
      ? BOM.DateTime(values.submittedOnDate, "only-date")
      : values.submittedOnDate;
    console.log(values);
    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    console.log(values);
    setFormData({ ...formData, terms: values });
    setCurrent(current + 1);
  };

  const onFinishChargesForm = (values) => {
    console.log(values);
    console.log(chargesValue);
    let payLoadData = [];
    chargesValue.forEach((element, index) => {
      const concatenatedAmountValue = `amount${index + 1}`;
      const concatenatedDateValue = `feeOnMonthDay${index + 1}`;
      payLoadData.push({
        chargeId: element.id,
        amount: values[concatenatedAmountValue],
        feeOnMonthDay: values[concatenatedDateValue]
          ? BOM.DateTimeWithoutYear(values[concatenatedDateValue], "only-date")
          : values[concatenatedDateValue],
      });
    });

    console.log(payLoadData);

    const payLoadMap = new Map(
      payLoadData.map((item) => [item.chargeId, item.amount, item.feeOnMonthDay])
    );
    const updatedChargesValue = chargesValue.map((item) => ({
      ...item,
      amount: payLoadMap.get(item.id) || item.amount,
      feeOnMonthDay: payLoadMap.get(item.id) || item.feeOnMonthDay,
    }));

    setFormData({
      ...formData,
      charges: values,
      payLoadValues: payLoadData,
      previewCharge: updatedChargesValue,
    });

    setCurrent(current + 1);
  };

  const getCustomerList = () => {
    setIsLoading(true);
    const params = {
      limit: 100,
      offset: 0,
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.Clients}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            value: element?.id,
            label: element?.displayName ? `${element?.displayName} (${element?.id})` : "-",
            accountNo: element?.accountNo ? element?.accountNo : "-",
            mobileNo: element?.mobileNo ? element?.mobileNo : "-",
            customerType: element?.legalForm ? element?.legalForm?.value : "-",
            externalId: element?.externalId ? element?.externalId : "-",
            status: element?.status ? element?.status.value : "-",
            branch: element?.officeName ? element?.officeName : "-",
            staff: element?.staffName ? element?.staffName : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setCustomerDetail(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getProductTemplate = (customerParam) => {
    setIsLoading(true);

    const url = `${apiConfig.savingsAccounts}/template?clientId=${customerParam.value}&staffInSelectedOfficeOnly=true`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempProducts = [];

        objList?.productOptions
          ?.filter((item) => item.allowOverdraft === false)
          .forEach((element) => {
            tempProducts.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        setProductData(tempProducts);
        setCustomerInfo(customerParam);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const getCustomerProductTemplate = (customerParam, productParam) => {
    setIsLoading(true);

    const url = `${apiConfig.savingsAccounts}/template?clientId=${customerParam.value}&productId=${productParam}&staffInSelectedOfficeOnly=true`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setTemplateProdDetail(res);
        const objList = res;
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationDaysInYearTypeOptions?.forEach((element) => {
          tempInterestCalculationDaysInYearTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.assetAccountOptions?.forEach((element) => {
          tempAssetOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.equityAccountOptions?.forEach((element) => {
          tempEquityOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach((element) => {
          tempExpenseOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach((element) => {
          tempIncomeOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach((element) => {
          tempLiabilityOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        const chargesLength = objList?.charges?.length || 0;
        setChargeTableCount(chargesLength);

        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic value={element?.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.FormatArrayDate(element?.feeOnMonthDay)
              : "-",
            feeInterval: element?.feeInterval?.value ? element?.feeInterval?.value : "-",
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setProductData(tempProducts);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(tempInterestCompoundingPeriodTypeOptions);
        setInterestPostingPeriodTypeOptions(tempInterestPostingPeriodTypeOptions);
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(tempInterestCalculationDaysInYearTypeOptions);
        setLockinPeriodFrequencyTypeOptions(tempLockinPeriodFrequencyTypeOptions);
        setChargeTableSource(tempCharges);

        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency.code
        );
        form.setFieldsValue({
          chargeId: "",
        });
        setChargesOptions([...chargeForTableData]);
        setIsLoading(false);
      }
    });
  };

  const forms = [
    <DetailForm
      onSearch={onSearch}
      customerInfo={customerInfo}
      showDetailsForm={showDetailsForm}
      onFinish={onFinishDetailsForm}
      form={form}
      initialValues={formData.details}
      onChangeProduct={onChangeProduct}
      productData={productData}
      fieldOfficerData={fieldOfficerData}
      handleSearchInTable={handleSearchInTable}
    />,

    <TermsForm
      onFinish={onFinishTermsForm}
      form={form}
      initialValues={formData.terms}
      currencyData={currencyData}
      interestCompoundingPeriodTypeOptions={interestCompoundingPeriodTypeOptions}
      interestPostingPeriodTypeOptions={interestPostingPeriodTypeOptions}
      interestCalculationTypeOptions={interestCalculationTypeOptions}
      interestCalculationDaysInYearTypeOptions={interestCalculationDaysInYearTypeOptions}
      lockinPeriodFrequencyTypeOptions={lockinPeriodFrequencyTypeOptions}
    />,

    <ChargesForm
      onFinish={onFinishChargesForm}
      form={form}
      initialValues={formData.charges}
      chargePlaceholder={BOM.handlePlaceholderMsg(labelConfig.charge, "select")}
      chargesList={chargesOptions}
      chargesData={charges}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      setChargesValue={setChargesValue}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      chargeTableCount={chargeTableCount}
      setChargeTableCount={setChargeTableCount}
    />,

    <Preview
      formData={formData}
      currencyData={currencyData}
      templateProdDetail={templateProdDetail}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/acc0102", { replace: false });
  }

  const onSubmit = (formValues) => {
    formValues = {
      ...formData.details,
      ...formData.terms,
    };

    // CHARGES STICT VALUES
    formValues.charges = formData.payLoadValues;
    formValues.clientId = customerInfo.value;

    delete formValues.customerSearch;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      monthDayFormat: "dd MMMM",
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.savingsAccounts,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editCurrentAccountMsg);
          navigate("/detail-current-account", { state: { id: res.clientId } });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-current-account", { state: { id: res.clientId } });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.editCurrentAccount}
        pageItems={staticConfig.editCurrentAccountBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {labelConfig.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                {/*Interractive Section */}
                <Row style={{ justifyContent: "space-between" }}>
                  {/* Navigation section */}
                  <Card
                    style={{
                      width: "20%",
                      height: "50%",
                      boxShadow: "0px 0px 10px 2px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      height: 600,
                    }}
                  >
                    <Steps
                      current={current}
                      onChange={onChange}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>Details form</Text>,
                        },

                        {
                          title: <Text strong>Terms form</Text>,
                        },

                        {
                          title: <Text strong>Charges form</Text>,
                        },

                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card
                    style={{
                      marginLeft: "auto",
                      width: "78%",
                      boxShadow: "0px 0px 10px 2px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      padding: 10,
                      height: 600,
                      overflowY: "scroll",
                    }}
                  >
                    <div>{forms[current]}</div>
                  </Card>
                </Row>
              </Col>
            </Row>

            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex justify="space-between" style={{ paddingLeft: "20px", paddingRight: "40px" }}>
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    Prev
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    Next
                  </Button>
                )}
                {isLastStep && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditCurrentAccount);
